import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Col, Grid, Row } from "react-bootstrap";

import {
  ROLENAMES,
  CONFIGURATION_KEY,
} from "provider/PermissionProvider/permissions";

import {
  CopyConfigV2,
  DeleteConfiguration,
  GetConfigurationList,
  UpdatePriorityV2,
  ExportConfiguration,
  ImportConfiguration,
} from "./action";
import Loader from "../../Loader";
import { Configurations } from "./Configurations";
import { Filters } from "../../Filter";
import { famOption } from "../../Filter/Filters";
import { Order } from "../../../constant";

import { ConfigurationActivityLogsPath } from "routes/paths";

const ConfigManagement = (props) => {
  const [isInitializing, setIsIntializing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    pagination: { currentPage: 1, pageSize: 10 },
    orderBy: Order.asc,
    search: "",

    family: -1,
    type: -1,
    version: -1,
  });

  useEffect(() => {
    setIsIntializing(true);
    refreshConfigurationList(setIsIntializing(false));
  }, []);

  useEffect(() => {
    refreshConfigurationList();
  }, [filter]);

  const refreshConfigurationList = async (callback = null) => {
    setIsLoading(true);
    props.GetConfigurationList(filter).then(() => {
      setIsLoading(false);
      if (callback) {
        callback();
      }
    });
  };

  const handleFilterValueChange = (state) => {
    setFilter({
      ...filter,
      family: state.family.value !== -1 ? state.family.value : -1,
      type: state.type.value !== -1 ? state.type.value : -1,
      version: state.version.value !== -1 ? state.version.value : -1,
      pagination: {
        ...filter.pagination,
        currentPage: 1,
      },
    });
  };

  const onSavePriority = (items) => {
    const configs = items.map((item, index) => {
      return { configuration_id: item.id, priority: index + 1 };
    });

    return props.UpdatePriorityV2(configs, filter.family);
  };

  const onHandleSearch = (searchCriteria) => {
    setFilter({
      ...filter,
      search: searchCriteria.searchText,
      pagination: {
        ...filter.pagination,
        currentPage: 1,
      },
    });
  };

  const onHandleTableChange = (type, state) => {
    if (type === "sort") {
      setFilter({
        ...filter,
        orderBy: state.sortOrder === "desc" ? Order.desc : Order.asc,
      });
    } else {
      setFilter({
        ...filter,
        pagination: {
          ...filter.pagination,
          currentPage: state.page,
          pageSize: state.sizePerPage,
        },
      });
    }
  };

  if (isInitializing) {
    return <Loader fullpage message="Loading configurations" />;
  }

  return (
    <Grid fluid>
      <h1>Configurations</h1>
      <Row>
        <Col md={10} mdPush={2}>
          <Configurations
            configs={props.configurationList}
            selectedUnit={filter}
            onToggleActivityLogs={() =>
              props.history.push(ConfigurationActivityLogsPath)
            }
            onFetchConfiguration={refreshConfigurationList}
            onDeleteConfiguration={DeleteConfiguration}
            onCopyConfiguration={CopyConfigV2}
            onExportConfiguration={ExportConfiguration}
            onImportConfiguration={ImportConfiguration}
            onSavePriority={onSavePriority}
            isLoading={isLoading}
            onHandleSearch={onHandleSearch}
            onHandleTableChange={onHandleTableChange}
            pagination={filter.pagination}
          />
        </Col>
        <Filters
          className="col-md-2 col-md-pull-10"
          onFilterValueChange={handleFilterValueChange}
          familyOption={famOption.FAMILY_UNITS}
          roleNameId={ROLENAMES[CONFIGURATION_KEY].id}
          hasFamily
          hasType
          hasVersion
        ></Filters>
      </Row>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    configurationList: state.configuration.configurationList,
    activityLogs: state.configuration.activityLogs,
  };
};

const mapDispatchToProps = {
  CopyConfigV2,
  DeleteConfiguration,
  GetConfigurationList,
  UpdatePriorityV2,
  ExportConfiguration,
  ImportConfiguration,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigManagement);
